import { reduce } from 'lodash/collection';
import { isFunction } from 'lodash/lang';

import { setIn } from '../../../services/immutable';

export const FRS_UNINITIALIZED = 'UNINITIALIZED';
export const FRS_LOADED = 'LOADED';
export const FRS_READY = 'READY';

export const ACTION_PERFORM = 'PERFORM';
export const ACTION_PERFORM_INITIALIZATION = 'PERFORM_INITIALIZATION';

const schemaStatuses = [FRS_UNINITIALIZED, FRS_LOADED, FRS_READY];

export default function reducer(state, action) {
  const { type, processor } = action;

  if (isFunction(processor)) {
    const nextState = processor(state, action);
    if (type === ACTION_PERFORM_INITIALIZATION) {
      return setIn(nextState, 'schema', createSchema(nextState));
    }
    return recalculateSchemaIfNeeded(state, nextState);
  }
  return state;
}

function recalculateSchemaIfNeeded(previousState, nextState) {
  const { schema } = nextState;

  if (previousState.schema !== schema) {
    const status = recalculateSchemaStatus(schema);
    if (schema.status !== status) {
      schema.status = status;
    }
  }

  return nextState;
}

function createSchema(state) {
  const currentSchema = state.schema || {};
  const predefinedKeys = Object.keys(state.schema || {});
  const skipKeys = [
    'cacheCollector',
    'createCacheProvider',
    'cacheProvider',
    'schema',
    'cache',
    'cacheKey',
    'version',
    ...predefinedKeys
  ];
  return reduce(
    state,
    function(a, v, k) {
      if (skipKeys.includes(k)) return a;
      a[k] = { status: FRS_UNINITIALIZED };
      return a;
    },
    {
      status: FRS_UNINITIALIZED,
      ...currentSchema
    }
  );
}

function recalculateSchemaStatus(schema) {
  const { status, ...rest } = schema;

  return reduce(
    rest,
    function(a, { status }) {
      const lastStatusIndex = schemaStatuses.indexOf(a);
      const currentStatusIndex = schemaStatuses.indexOf(status);
      if (currentStatusIndex < lastStatusIndex) {
        return status;
      }
      return a;
    },
    FRS_READY
  );
}
